import { render, staticRenderFns } from "./OperatingRiskDetail.vue?vue&type=template&id=1d3f5382&scoped=true"
import script from "./OperatingRiskDetail.vue?vue&type=script&lang=js"
export * from "./OperatingRiskDetail.vue?vue&type=script&lang=js"
import style0 from "./OperatingRiskDetail.vue?vue&type=style&index=0&id=1d3f5382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f5382",
  null
  
)

export default component.exports